<template>
  <svg
    :class="['icon', { 'icon--expand': !isSizePassed }]"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    focusable="false"
    aria-hidden="true"
  >
    <use :xlink:href="`#${glyph}`" />
  </svg>
</template>

<script>
// растягивается на всю ширину и высоту родительского контейнера // если не
// указана ширина или высота

export default {
  name: 'Icon',
  props: {
    width: { type: Number, required: false },
    height: { type: Number, required: false },
    glyph: { type: String, required: true },
  },
  computed: {
    isSizePassed() {
      const { width, height } = this;
      return width !== undefined || height !== undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;

  &--expand {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
}
</style>
